import { CourseLevel } from "@shared_types";

export const getProgressColors = (progress?: number) => {
  let progressColor = "var(--color-grey)";
  // iOS CourseProgressIndicator uses GreyLightest (#f5f5f5) for the track.
  const progressTrackColor = "var(--color-grey-lightest)";

  if (progress !== undefined) {
    if (progress <= 33) {
      progressColor = "var(--color-yellow)";
    } else if (progress <= 66) {
      progressColor = "var(--color-blue)";
    } else {
      progressColor = "var(--color-green)";
    }
  }

  return { progressColor, progressTrackColor };
};

/**
 * Map a level difficulty (1-6) to its iOS color.
 * Mirrors client-native LevelCycleButton.getLevelColor + CourseLevelBadge:
 *   1 → green, 2/3 → blue, 4 → yellow, 5 → orange, 6 → red.
 */
export const getLevelColorByDifficulty = (difficulty?: number) => {
  const palette = [
    "var(--color-green)", // 1 Super Beginner
    "var(--color-blue)", // 2 Beginner
    "var(--color-blue)", // 3 Upper Beginner
    "var(--color-yellow)", // 4 Intermediate
    "var(--color-orange)", // 5 Upper Intermediate
    "var(--color-red)", // 6 Advanced
  ];
  if (difficulty === undefined) return "var(--color-grey)";
  const idx = Math.min(Math.max(difficulty - 1, 0), palette.length - 1);
  return palette[idx];
};

export const getLevelColor = (level?: CourseLevel) => {
  // Prefer difficulty (the iOS source of truth) so the color map stays in one place.
  if (level?.difficulty) {
    return getLevelColorByDifficulty(level.difficulty);
  }

  let levelColor = "var(--color-grey)";

  if (level?.name === "Super Beginner") {
    levelColor = "var(--color-green)";
  } else if (level?.name === "Beginner" || level?.name === "Upper Beginner") {
    levelColor = "var(--color-blue)";
  } else if (level?.name === "Intermediate") {
    levelColor = "var(--color-yellow)";
  } else if (level?.name === "Upper Intermediate") {
    levelColor = "var(--color-orange)";
  } else if (level?.name === "Advanced") {
    // iOS: Advanced = Error red (#c72d25), NOT orange.
    levelColor = "var(--color-red)";
  }

  return levelColor;
};
